import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const BenefitsSection = () => {
  const benefits = [
  {
    icon: 'Zap',
    title: 'AI-Powered Assistance',
    description: 'Integrated AI bot helps students with questions during their learning trail'
  },
  {
    icon: 'Users',
    title: 'Classroom Management',
    description: 'Easily organize students by class and create secure login credentials'
  },
  {
    icon: 'Lock',
    title: 'Secure & Private',
    description: 'Teacher-controlled access ensures student data privacy and security'
  },
  {
    icon: 'Smartphone',
    title: 'Mobile-Friendly',
    description: 'Students can access learning trails on any device with QR scanning'
  }];


  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4 md:mb-6">
              Built for Modern Education
            </h2>
            <p className="text-base md:text-lg text-muted-foreground mb-6 md:mb-8">
              LearningTrails combines cutting-edge technology with intuitive design to help teachers create memorable educational experiences that students love.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
              {benefits?.map((benefit, index) =>
              <div key={index} className="flex items-start stagger-fade-in" style={{ animationDelay: `${index * 150}ms` }}>
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                    <Icon name={benefit?.icon} size={20} className="text-primary md:w-6 md:h-6" />
                  </div>
                  <div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">
                      {benefit?.title}
                    </h3>
                    <p className="text-xs md:text-sm text-muted-foreground">
                      {benefit?.description}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <Image
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1e56c0a8a-1766825006595.png"
                alt="Female teacher with warm smile helping young student with tablet device in bright modern classroom with colorful educational posters on walls"
                className="w-full h-64 md:h-80 lg:h-96 object-cover" />
              
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default BenefitsSection;